import PartnerUserKeys from './partnerUserKeys/operations';
import PartnerKeys from './partnerKeys/operations';

export default {
  PartnerUserKeys,
  PartnerKeys,
};
